import React from "react";

import { Code, HelpIcon, Typography } from "@packages/ds";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";

import * as S from "./CompleteConfigurationInfo.styles";

type CompleteConfigurationInfoProp = {
  customDomainName: string;
};

const CompleteConfigurationInfo = ({
  customDomainName
}: CompleteConfigurationInfoProp) => {
  const { environmentId, organizationId, projectId } = useDecodedParams<{
    environmentId: string;
    organizationId: string;
    projectId: string;
  }>();
  const navigate = useNavigate();

  const environment = useSelectorWithUrlParams(environmentSelector);

  function domainList() {
    navigate(
      `/${organizationId}/${projectId}/${environmentId}/settings/domains`
    );
  }

  const intl = useIntl();

  return (
    <S.MainContainer key="confirmation-domain-info">
      <Typography.Title tag="h3" className="status_active_description">
        {intl.formatMessage({ id: "domains.complete.configuration.title" })}
      </Typography.Title>

      <S.CompleteCodyText className="status_active_description">
        {intl.formatMessage(
          {
            id: "domains.complete.configuration.description"
          },
          {
            customDomain: customDomainName
          }
        )}
      </S.CompleteCodyText>

      <S.Help>
        <HelpIcon />
        {intl.formatMessage(
          { id: "settings.domains.learn_more.add_domain" },
          {
            link: (...chunks) => (
              <S.Link
                analyticId="links.domains.replacement"
                href={intl.formatMessage({ id: "links.domains.replacement" })}
              >
                {chunks}
              </S.Link>
            )
          }
        )}
      </S.Help>

      <S.CopyWrapper>
        <S.CopyLabel>
          {intl.formatMessage({ id: "settings.domains.cname.target" })}
        </S.CopyLabel>
        <Code.Block
          isCopyable
          id={`${environment?.edge_hostname}.`}
        >{`${environment?.edge_hostname}.`}</Code.Block>
      </S.CopyWrapper>

      <S.ButtonModalContainer>
        <S.ConfirmationButton
          analyticId="okay"
          id="complete-confirmation-btn"
          type="submit"
          onClick={() => {
            domainList();
          }}
        >
          {intl.formatMessage({ id: "okay" })}
        </S.ConfirmationButton>
      </S.ButtonModalContainer>
    </S.MainContainer>
  );
};

export default CompleteConfigurationInfo;
